import React from "react";
import data from "../../json/Contactus/Contactus1.json";
import { Link } from "react-router-dom";

const Contactus1 = () => {
  return (
    <div className="w-full flex justify-center">
      <div className="w-full 2xl:container md:px-20 px-6 md:py-20 py-[72px]">
        <div className="w-full flex flex-col items-center gap-4">
          <h1 className="text-32 md:text-48 lg:text-64 text-primarycolor text-center font-semibold">
            {data.Title}
          </h1>
          <p className="text-base md:text-18 text-secondaryblack font-regular">
            {data.subtitle}
          </p>
        </div>
        <div className="mt-14 grid gap-[31px] lg:grid-cols-3 md:grid-cols-2 grid-cols-1 max-md:place-items-center">
          {data.countries.map((item, i) => (
            <div
              key={i}
              className=" max-sm:w-full max-[769px]:w-2/3 w-full w-full h-auto  flex justify-between flex-col gap-4 p-8 rounded-[24px] border-[1px] border-journyborder shadow-services"
            >
              <div className="flex gap-4 items-center">
                <img
                  src={process.env.PUBLIC_URL + item.icon}
                  className="h-12 w-12"
                  alt="location_icon"
                />
                <h1 className=" text-24 md:text-32 font-semibold text-primarycolor">{item.country}</h1>
              </div>
              <p className=" text-16 md:text-18 text-secondaryblack">{item.address}</p>
              <div className="flex flex-col justify-start gap-4 mt-4">
              <div className="phoneicon flex items-center gap-4">
                <p className=" text-16 md:text-18 font-medium text-sendaryblack">{item.Phone}</p>
              </div>
             {item.whatsapp && <div className="whatsappicon flex items-center gap-4  ">
                <p className=" text-16 md:text-18 font-medium text-sendaryblack">{item.whatsapp}</p>
              </div>}
              </div>
              <Link
                to={item.map}
                target="_"
                className="googlelink bio font-semibold mt-4 "
              >
                View on Google Maps
              </Link>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Contactus1;
